import { columnTypes } from '@qdabra/forms-shared/sharePoint';
import { getParameterByName } from '@qdabra/forms-shared/urlHelpers';
import { childEl } from '@qdabra/forms-shared/xmlHelpers';
import { nsQ } from '@qdabra/forms-shared/xmlNamespaces';
import { URL_PARAMETER_DOCUMENT } from '../../constants/url.parameter.names';
import { getQueryXml } from '../dataConnection.utils';

const { SP_TYPE_BOOLEAN, SP_TYPE_COUNTER } = columnTypes;

const INVALID_FIELD_VALUE = {};

function convertBoolean(value) {
    // empirically verified in InfoPath - this conversion is case sensitive (requires XML boolean values)
    if (value === 'true' || value === '1') {
        return '1';
    }
    if (value === 'false' || value === '0') {
        return '0';
    }

    return INVALID_FIELD_VALUE;
}

function convertFieldValue(type, value) {
    if (!value) {
        return null;
    }

    if (type === SP_TYPE_BOOLEAN) {
        return convertBoolean(value);
    }

    return value;
}

const makeFilterField = (field, value) => ({
    field,
    value,
});

export const idFilterField = (id) =>
    makeFilterField(
        {
            internalName: 'ID',
            type: SP_TYPE_COUNTER,
        },
        id,
    );

const getFilterField = (queryFieldsNode) => (fieldDef) => {
    const fieldNode = childEl(fieldDef.internalName, nsQ)(queryFieldsNode);

    if (!fieldNode) {
        return null;
    }

    const fieldValue = fieldNode.textContent;
    const convertedValue = convertFieldValue(fieldDef.type, fieldValue);

    if (convertedValue === INVALID_FIELD_VALUE) {
        throw new Error(
            'Invalid value for column "' +
                fieldDef.internalName +
                '" specified in the query fields.',
        );
    }

    return makeFilterField(fieldDef, convertedValue);
};

const shouldUseFilterField = (filterField) => filterField?.value;

function getQueryFields(fields, dataSource) {
    const queryFieldsNode = getQueryXml(dataSource.getDom());

    return fields
        .map(getFilterField(queryFieldsNode))
        .filter(shouldUseFilterField);
}

const fileLeafFilterField = (fileName) =>
    makeFilterField(
        {
            internalName: 'FileLeafRef',
            type: 'File',
        },
        fileName,
    );

function getDocumentFilter() {
    const documentUrl = getParameterByName(URL_PARAMETER_DOCUMENT);

    if (!documentUrl) {
        return null;
    }

    const splitUrl = documentUrl.split('/');
    const fileName = splitUrl[splitUrl.length - 1];

    if (!fileName.match(/\.xml$/i)) {
        return null;
    }

    return fileLeafFilterField(fileName);
}

// FilterField is
// {
//     field: { internalName: String, type: String },
//     value: String,
// }

// (SharePointListAdapter, DataSource) -> [FilterField]
const getAllQueryFields = (adapter, dataSource) =>
    [
        ...getQueryFields(adapter.fields, dataSource),
        adapter.isQueryCurrentItem ? getDocumentFilter() : null,
    ].filter(Boolean);

export default getAllQueryFields;
